import { DatalayerItem, TrackingService } from '@rocheglobal/component-library/src/services/tracking';
import React, { useEffect, useState } from 'react';
import { useScrollPercentage } from 'react-scroll-percentage';
import { BrowserDetectionService } from '../../services';
import { AdobeTracking } from '../../tracking';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const trackPageScrollDepth = (scrollDepth: number, data: any): void => {
  if (!BrowserDetectionService.isBrowserContext()) {
    return;
  }

  TrackingService.push({
    component_name: '',
    event: 'page_scroll_depth',
    additionalParameters: {
      page_scroll_depth: `${scrollDepth * 100}%`,
    },
  } as DatalayerItem);

  if (scrollDepth === 0.75) {
    const updatedData = {
      ...data,
      scrolled: 75,
    };

    AdobeTracking(updatedData, 'scroll');
  }
};

const handleScrollTracking = (
  scrollDepth: number,
  trackDepths: number[],
  setTrackDepths: React.Dispatch<React.SetStateAction<number[]>>,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  data: any,
): void => {
  const eventsToTrack = trackDepths.filter((depth) => depth <= scrollDepth);

  if (eventsToTrack.length <= 0) {
    return;
  }
  eventsToTrack.forEach((depthPoint) => trackPageScrollDepth(depthPoint, data));

  const difference = trackDepths.filter((value): boolean => !eventsToTrack.includes(value));
  setTrackDepths(difference);
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const ScrollTracking = ({ data }: any): JSX.Element => {
  const [trackDepths, setTrackDepths] = useState([0.25, 0.50, 0.75, 1]);

  const [ref, scrollDepth] = useScrollPercentage({
    threshold: 0.25,
  });

  useEffect(() => {
    document.body.style.position = 'relative';
  }, []);

  handleScrollTracking(scrollDepth, trackDepths, setTrackDepths, data);

  return (
    <div
      ref={ref}
      style={{
        height: '100%',
        position: 'absolute',
        top: '0',
        left: '0',
      }}>
    </div>
  );
};
